import { ButtonsContainer, PrimaryButton, SecondaryButton, SuccessButton } from '@cmg/common';
import { xcSelectors } from '@cmg/e2e-selectors';
import React from 'react';

import { MdlAllocationIoiType } from '../../../../graphql';
import SideBarSectionHeader from '../side-bar-header/SideBarHeader';
import { SFirmLevelDemandHeader } from './FirmLevelDemandBar.styles';

type FirmLevelDemandBarProps = {
  isEditing?: boolean;
  onChangeEditing: () => void;
  ioiType?: MdlAllocationIoiType;
  onSubmitForm: () => void;
  onResetForm: () => void;
  loading?: boolean;
  title?: string;
  hasAllocationRanking?: boolean;
  hasFullAccess: boolean;
};

type Props =
  | (FirmLevelDemandBarProps & { convertableToPassOrRegM: false })
  | (FirmLevelDemandBarProps & {
      convertableToPassOrRegM: true;
      onChangeIoiType: (ioiType: MdlAllocationIoiType) => void;
    });

const FirmLevelDemandBar = (props: Props) => {
  const {
    ioiType,
    title,
    loading,
    hasAllocationRanking,
    onChangeEditing,
    isEditing,
    onResetForm,
    onSubmitForm,
    hasFullAccess,
  } = props;

  const isNormalIoiType = !ioiType || ioiType === MdlAllocationIoiType.Normal;
  const displayEdit = !isEditing && isNormalIoiType && hasFullAccess;
  const displayRegMAndPass = isNormalIoiType && hasFullAccess;

  return (
    <SideBarSectionHeader title={title}>
      <SFirmLevelDemandHeader>
        <ButtonsContainer>
          {!isNormalIoiType && props.convertableToPassOrRegM && (
            <SuccessButton
              onClick={() => props.onChangeIoiType(MdlAllocationIoiType.Normal)}
              disabled={!hasFullAccess || loading}
              testId={xcSelectors.firmLevelDemandBarReActivateIndication.testId}
              loading={loading}
            >
              Re-activate Indication
            </SuccessButton>
          )}
          {displayRegMAndPass && props.convertableToPassOrRegM && (
            <React.Fragment>
              <SecondaryButton
                onClick={() => props.onChangeIoiType(MdlAllocationIoiType.Pass)}
                disabled={loading || hasAllocationRanking}
                testId={xcSelectors.firmLevelDemandBarPassIndication.testId}
              >
                Pass
              </SecondaryButton>
              <SecondaryButton
                onClick={() => props.onChangeIoiType(MdlAllocationIoiType.RegM)}
                disabled={loading || hasAllocationRanking}
                testId={xcSelectors.firmLevelDemandBarRegMIndication.testId}
              >
                Reg-M
              </SecondaryButton>
            </React.Fragment>
          )}
          {displayEdit && (
            <PrimaryButton
              onClick={onChangeEditing}
              disabled={loading}
              testId={xcSelectors.firmLevelDemandBarEditIndication.testId}
            >
              Edit
            </PrimaryButton>
          )}
          {isEditing && isNormalIoiType && (
            <React.Fragment>
              <SecondaryButton
                onClick={onResetForm}
                testId={xcSelectors.firmLevelDemandBarDiscardChanges.testId}
                disabled={loading}
              >
                Discard Changes
              </SecondaryButton>
              <SuccessButton
                onClick={onSubmitForm}
                testId={xcSelectors.firmLevelDemandBarSaveChanges.testId}
                loading={loading}
                disabled={loading}
              >
                Save
              </SuccessButton>
            </React.Fragment>
          )}
        </ButtonsContainer>
      </SFirmLevelDemandHeader>
    </SideBarSectionHeader>
  );
};

export default FirmLevelDemandBar;
